import { CSSProperties } from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import { IconType } from "react-icons";
import { LoadingOutlined } from "@ant-design/icons";

import { stateGlobal } from "../../../../interfaces/Global";

interface IProps {
    IconComponent: IconType;
    title: string;
    value: string;
    iconColor?: string;
    iconBackgroundColor?: string;
    onClick?: () => void;
    style?: CSSProperties;
    showLoading?: boolean;
    iconSize?: number;
    fontSize?: number;
}

export default function CardInformacao({
    IconComponent,
    title,
    value,
    iconColor,
    iconBackgroundColor,
    onClick,
    style,
    showLoading,
    iconSize = 18,
    fontSize = 14,
}: IProps) {
    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <div
            onClick={onClick}
            style={{
                display: 'flex',
                gap: 12,
                padding: '8px 12px',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: propsState.theme === 'light' ? '#0000000f' : '#ffffff1f',
                borderRadius: 8,
                alignItems: 'center',
                height: "100%",
                cursor: onClick ? 'pointer' : 'default',
                ...style,
            }}
        >
            <div
                style={{
                    width: iconSize * 2,
                    height: iconSize * 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: iconBackgroundColor || (propsState.theme === 'light' ? '#f0f2f5' : "#1D1D1D"),
                    borderRadius: 8
                }}
            >
                {
                    !showLoading ? (
                        <IconComponent
                            size={iconSize}
                            color={iconColor || undefined}
                        />
                    ) : (
                        <LoadingOutlined
                            size={iconSize}
                            style={{ color: iconColor || undefined }}
                        />
                    )
                }
            </div>

            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4,
                    overflow: 'hidden'
                }}
            >
                <Typography.Text
                    strong
                    type="secondary"
                    style={{ fontSize: fontSize - 2 }}
                >
                    {title}
                </Typography.Text>

                <Typography.Text
                    strong
                    ellipsis={{ tooltip: value }}
                    style={{ marginTop: -6, fontSize }}
                >
                    {value}
                </Typography.Text>
            </div>
        </div>
    )
}
